import React, { useEffect, useRef, useState } from 'react';
import { FileText, ExternalLink, TrendingUp, Loader2 } from 'lucide-react';

import { researchArticles } from '../mock';

const ResearchSection = () => {
  const [research, setResearch] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchResearch = async () => {
      try {
        const defaultUrl = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';
        const API_URL = process.env.REACT_APP_API_URL || defaultUrl;
        const response = await fetch(`${API_URL}/api/research`);
        if (response.ok) {
          const data = await response.json();
          if (data && data.length > 0) {
            setResearch(data);
          } else {
            setResearch(researchArticles); // Fallback to mocks
          }
        } else {
          setResearch(researchArticles);
        }
      } catch (err) {
        console.error("Fetch research failed", err);
        setResearch(researchArticles);
      } finally {
        setLoading(false);
      }
    };
    fetchResearch();
  }, []);

  return (
    <section
      id="research"
      className="py-16 relative"
      style={{ background: '#FFFFFF' }}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 px-4 py-1.5 rounded-full mb-4" style={{ background: '#F6F6F6' }}>
            <TrendingUp className="w-4 h-4" style={{ color: '#1E56A0' }} />
            <span className="text-sm font-medium" style={{ color: '#163172' }}>Evidence-Based Approach</span>
          </div>

          <h2
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ fontFamily: 'Merriweather, serif', color: '#163172' }}
          >
            Grounded in Research
          </h2>
          <p
            className="text-base md:text-lg max-w-3xl mx-auto leading-relaxed"
            style={{ color: '#000000' }}
          >
            Our approach is informed by decades of research on social engagement and cognitive health.
          </p>
        </div>

        {/* Research articles */}
        <div
          className="flex space-x-6 overflow-x-auto pb-8 mb-4 px-4 -mx-4 custom-scrollbar"
          style={{
            scrollbarWidth: 'thin',
            scrollbarColor: '#D6E4F0 transparent'
          }}
        >
          {research.map((article) => (
            <div
              key={article.id}
              className="flex-shrink-0 w-[350px] md:w-[450px] p-8 rounded-2xl border border-[#D6E4F0] hover:bg-white transition-all duration-300 shadow-sm hover:shadow-md animate-in fade-in slide-in-from-right duration-500"
              style={{ background: '#FFFFFF' }}
            >
              <div className="flex flex-col h-full">
                <div className="flex items-center space-x-4 mb-6">
                  <div
                    className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
                    style={{ background: '#F6F6F6' }}
                  >
                    <FileText className="w-6 h-6" style={{ color: '#1E56A0' }} />
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-xl font-bold truncate" style={{ color: '#163172' }}>
                      {article.title}
                    </h3>
                    <p className="text-sm font-medium" style={{ color: '#1E56A0' }}>
                      {article.source} • {article.year}
                    </p>
                  </div>
                </div>
                <p className="leading-relaxed text-black mb-6 flex-1 line-clamp-4">
                  {article.summary}
                </p>

                {article.url && (
                  <div className="mt-auto pt-4 border-t border-[#F6F6F6]">
                    <a
                      href={article.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center text-sm font-bold transition-all hover:underline"
                      style={{ color: '#1E56A0' }}
                    >
                      View Full Publication
                      <ExternalLink className="w-3.5 h-3.5 ml-1.5" />
                    </a>
                  </div>
                )}
              </div>
            </div>
          ))}

          {loading && (
            <div className="flex items-center justify-center p-8 min-w-[200px]">
              <Loader2 className="w-8 h-8 animate-spin text-[#1E56A0]" />
            </div>
          )}
        </div>

        {/* Statistics */}
        {/* <div className="grid md:grid-cols-3 gap-8">
          {[
            { value: '85%', label: 'Improvement in mood scores after regular engagement' },
            { value: '72%', label: 'Of caregivers report reduced stress with support' },
            { value: '94%', label: 'Of volunteers report increased empathy and purpose' }
          ].map((stat, idx) => (
            <div
              key={idx}
              className="text-center p-8 rounded-2xl border border-[#D6E4F0]"
              style={{ background: '#F6F6F6' }}
            >
              <div className="text-4xl font-bold mb-2" style={{ color: '#163172' }}>{stat.value}</div>
              <p className="text-sm font-medium" style={{ color: '#000000' }}>
                {stat.label}
              </p>
            </div>
          ))}
        </div> */}
      </div>
    </section>
  );
};


export default ResearchSection;
